/* Goi y nut Customize — 24/09 (chu shop, theo cach handdn lam).

   Vao trang, nut tu bung ra chu "Customize this strap" ~5 giay roi thu ve icon. Muc dich la
   cho khach BIET cai nut do lam gi; da biet roi thi khong can nhac lai, nen chi chay MOT LAN
   moi phien (sessionStorage).

   Ba cho dung lai, deu co ly do:
   - prefers-reduced-motion: khong chay. Mot vat tu dong nhuc nhich la thu nguoi nhay cam voi
     chuyen dong da tat di o cap he dieu hanh.
   - Khach da re chuot vao nut trong 600ms dau: khong chay. Ho dang tu kham pha roi.
   - sessionStorage bi chan (tab an danh, chan site data): try/catch, coi nhu chua chay, hieu
     ung van dien ra mot lan cho lan tai trang do — kem hon la vo hieu hoa han. */
(function () {
  'use strict';
  try {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  } catch (e) {}

  var KHOA = 's2d-goi';
  try { if (sessionStorage.getItem(KHOA)) return; } catch (e) {}

  function chay() {
    var ns = [].slice.call(document.querySelectorAll('.s2d--card[data-s2d]'));
    if (!ns.length) return;
    var daRe = false;
    ns.forEach(function (n) {
      n.addEventListener('pointerenter', function () { daRe = true; }, { once: true });
    });
    setTimeout(function () {
      if (daRe) return;
      try { sessionStorage.setItem(KHOA, '1'); } catch (e) {}
      ns.forEach(function (n) { n.classList.add('is-goi'); });
      setTimeout(function () {
        ns.forEach(function (n) { n.classList.remove('is-goi'); });
      }, 5000);
    }, 600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', chay);
  else chay();
})();
